import {
  CHANGE_EDITABLE_STAKEHOLDER,
  SET_IS_MULTIPLE_SIGNATORIES_JOURNEY,
  SET_SIGNATORY_ID,
  SET_STAKEHOLDER_STATUS_TYPE,
  UPDATE_STAKEHOLDERS_IDS
} from "../actions/stakeholders";
import { handleActions } from "../../utils/redux-utils";
import { RESET_PROSPECT } from "../actions/appConfig";

export const initialState = {
  editableStakeholder: null,
  stakeholdersIds: [],
  selectedSignatoryId: "",
  stakeholderStatusType: {},
  isMultipleSignatoriesJourney: false
};

export default handleActions(
  {
    [CHANGE_EDITABLE_STAKEHOLDER]: (state, { payload }) => ({
      ...state,
      editableStakeholder: payload
    }),
    [UPDATE_STAKEHOLDERS_IDS]: (state, { payload }) => ({
      ...state,
      stakeholdersIds: payload
    }),
    [SET_SIGNATORY_ID]: (state, action) => ({
      ...state,
      selectedSignatoryId: action.payload
    }),
    [SET_STAKEHOLDER_STATUS_TYPE]: (state, action) => ({
      ...state,
      stakeholderStatusType: action.payload
    }),
    [RESET_PROSPECT]: state => ({
      ...state,
      stakeholderStatusType: {}
    }),
    [SET_IS_MULTIPLE_SIGNATORIES_JOURNEY]: (state, action) => ({
      ...state,
      isMultipleSignatoriesJourney: action.payload
    })
  },
  initialState
);
